import React, { ReactNode } from 'react';

interface SidebarSubmenuProps {
  children: ReactNode;
}

const SidebarSubmenu = ({ children }: SidebarSubmenuProps) => <ul className="sidebar-submenu">{children}</ul>;

export default SidebarSubmenu;
